module.exports = __webpack_public_path__ + "img/varilux-white.d31cf641.svg";